import React, { FunctionComponent } from 'react'

import { useField, useFormikContext } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import { DateRangePicker } from '@/atoms/input'
import { convertDateToString } from '@/helpers/date'

import FieldWrapper from './field-wrapper'

export interface DateRangePickerProps {
  fieldProps?: SpaceProps & WidthProps
  name?: string
  onChange?: (dateRange: { startDate: Date; endDate: Date }) => void
  maxDate?: Date
  minDate?: Date
  startLabel?: string
  endLabel?: string
  hideErrorMessage?: boolean
  tooltip?: string
}

const DateRangePickerField: FunctionComponent<DateRangePickerProps> = ({
  fieldProps,
  name,
  onChange,
  minDate,
  maxDate,
  startLabel,
  endLabel,
  hideErrorMessage,
  tooltip,
}) => {
  const [field, meta] = useField(name)
  const { setFieldValue } = useFormikContext()
  const keys = Object.keys(field.value)
  const startDate = field.value[keys[0]] || null
  const endDate = field.value[keys[1]] || null

  const handleChange = (value: { startDate: Date; endDate: Date }): void => {
    setFieldValue(keys[0], convertDateToString(value.startDate))
    setFieldValue(keys[1], convertDateToString(value.endDate))
    setFieldValue(name, {
      [keys[0]]: convertDateToString(value.startDate),
      [keys[1]]: convertDateToString(value.endDate),
    })
    onChange && onChange(value)
  }

  return (
    <FieldWrapper id={field.name} fieldProps={fieldProps} hideErrorMessage={hideErrorMessage} tooltip={tooltip}>
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onChange={handleChange}
        minDate={minDate}
        maxDate={maxDate}
        startLabel={startLabel}
        endLabel={endLabel}
        startError={meta.touched && meta.error && meta.error[keys[0]]}
        endError={meta.touched && meta.error && meta.error[keys[1]]}
      />
    </FieldWrapper>
  )
}

DateRangePickerField.displayName = 'DateRangePickerField'

export default DateRangePickerField
